/**
 * Платёж за тариф, который ждёт подтверждения (S19). Хранится на устройстве:
 * страница оплаты уводит из приложения (PWA - в этой же вкладке, мини-приложение -
 * во внешний браузер), а после возврата экран должен найти платёж и
 * перечитать его статус. localStorage, а не sessionStorage: возврат по
 * return_url может прийти в новой вкладке.
 *
 * Хранилище может быть недоступно (приватный режим, запрет сайта) - тогда
 * просто ничего не помним, экран подписки работает и без этого.
 */

const KEY = 'procoach_pending_tier_payment'
/** Старше суток - не напоминаем: такой платёж банк уже отменил или провёл. */
const MAX_AGE_MS = 24 * 60 * 60 * 1000

export interface PendingPayment {
  id: string
  /** Тариф, на который платили: после оплаты сверяем, что он применился. */
  tier: string
  /** Страница оплаты: вернуться к ней, если её закрыли. */
  url: string
  /** ISO */
  createdAt: string
}

export function savePendingPayment(p: PendingPayment): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(p))
  } catch {
    // хранилище недоступно - статус всё равно виден на экране платежа
  }
}

export function loadPendingPayment(now = Date.now()): PendingPayment | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const p = JSON.parse(raw) as PendingPayment
    if (!p?.id || !p.createdAt) return null
    if (now - new Date(p.createdAt).getTime() > MAX_AGE_MS) return null
    return p
  } catch {
    return null
  }
}

/** Платёж завершён (прошёл, отменён, не прошёл) - больше не напоминаем. */
export function clearPendingPayment(id?: string): void {
  try {
    if (id) {
      const raw = localStorage.getItem(KEY)
      if (raw && (JSON.parse(raw) as PendingPayment)?.id !== id) return
    }
    localStorage.removeItem(KEY)
  } catch {
    // нечего чистить
  }
}
